import { put, takeLatest, takeEvery, call } from "redux-saga/effects";
import request from "utils/api";
import _pick from "lodash/pick";
import { safe } from "providers/GeneralProvider/saga";
import {
  popupGetConversationListRequest,
  popupGetConversationListSuccess,
  popupStopLoading,
  popupGetMessageListRequest,
  popupGetMessageListSuccess,
  popupSendMessageRequest,
  popupSendMessageSuccess,
  popupSendMessageFailure,
  popupSeenConversationRequest,
  popupSeenConversationSuccess,
  popupSetConversationDetail,
} from "providers/ChatPopupProvider/slice";

function* handleGetConversationList(action) {
  const params = _pick(action.payload, ["limit", "page"]);
  params.role = "fonehouse";
  params.type = "FONEHOUSE_TO_USER";

  const { data } = yield call(request, "api/chat/conversations", params, {
    method: "GET",
  });

  yield put(
    popupGetConversationListSuccess({
      list: data.docs,
      page: action.payload.page,
      hasNextPage: data.hasNextPage,
    })
  );
}

function* handleGetMessageList(action) {
  const params = _pick(action.payload, [
    "limit",
    "time",
    "conversationId",
  ]);
  const { data } = yield call(
    request,
    "api/chat-message/messages-admin",
    params,
    { method: "GET" }
  );

  yield put(
    popupGetMessageListSuccess({
      conversationId: params.conversationId,
      list: data,
      time: action.payload.time,
    })
  );
}

function* handleSendMessage(action) {
  const { conversationId } = action.payload;
  try {
    const params = _pick(action.payload, [
      "text",
      "type",
      "conversationId",
      "attachments",
      "productId",
    ]);

    const { data } = yield call(
      request,
      "api/chat-message/message-admin",
      params,
      { method: "POST" }
    );

    yield put(popupSendMessageSuccess({ conversationId, message: data }));
    yield put(popupSeenConversationRequest({ conversationId }));
  } catch (error) {
    yield put(popupSendMessageFailure({ conversationId }));
    throw error;
  }
}

function* handleSeenConversation(action) {
  const { conversationId } = action.payload;
  if (conversationId) {
    yield call(
      request,
      "api/chat-message/seen-message",
      { conversationId },
      { method: "POST" }
    );
    yield put(popupSeenConversationSuccess({ conversationId }));
  }
}

function* handleGetConversationDetail(action) {
  const { conversationId } = action.payload;
  if (conversationId) {
    const { data } = yield call(
      request,
      `api/chat/conversation/${conversationId}`,
      undefined,
      { method: "GET" }
    );
    yield put(
      popupSetConversationDetail({ conversationId, detail: data })
    );
  }
}

function* onError() {
  yield put(popupStopLoading());
}

export default function* watchChatPopup() {
  yield takeLatest(
    popupGetConversationListRequest.type,
    safe(handleGetConversationList, onError)
  );
  yield takeEvery(
    popupGetMessageListRequest.type,
    safe(handleGetMessageList, onError)
  );
  yield takeEvery(
    popupSendMessageRequest.type,
    safe(handleSendMessage, onError)
  );
  yield takeEvery(
    popupSeenConversationRequest.type,
    safe(handleSeenConversation, onError)
  );
  // Reuse for fetching conversation detail when opening a window
  yield takeEvery(
    "chatPopup/fetchConversationDetail",
    safe(handleGetConversationDetail, onError)
  );
}
